import React from "react";
import {useGetData, useManageItems} from "../pages-lib/user-status-groups/model";
import {useUpdateHeaderTitle, usePermission} from "../hooks";
import {getColumns} from "../pages-lib/user-status-groups/table-columns";
import {ExtraButtons} from "../components/extra-buttons";
import {Header} from "../components/layout/header";
import styled from "styled-components";
import { Table as AntTable } from "antd";
import {getFormattedItems} from "../pages-lib/user-status-groups/model/use-get-data";
import {VisibilityProvider} from "../components/visibility-provider";
import {EditDrawer} from "../pages-lib/user-status-groups/edit-drawer";

export default function UserStatusGroups() {
    const { hasPermission } = usePermission()
    const [editDrawerState, setEditDrawerState] = React.useState(false)

    const { dataItems, isLoading, refetch: getItems } = useGetData();
    const { editData, onEditItem, onSaveEdit } = useManageItems(dataItems, getItems, onSuccessEdit);

    const headerTitle = useUpdateHeaderTitle({
        items: dataItems,
        defaultTitle: "0 Групп",
        arrType: ["Группа", "Группы", "Групп"],
    });

    function onSuccessEdit() {
        setEditDrawerState(!editDrawerState)
    }

    const columns = getColumns(hasPermission("user-status-groups.edit") ? onEditItem : null)

    return (
        <>
            <Header title={headerTitle} extra={<ExtraButtons />} />

            <StyledTable
                dataSource={getFormattedItems(dataItems)}
                columns={columns}
                loading={isLoading}
                pagination={false}
            />

            {hasPermission("user-status-groups.edit") && (
                <VisibilityProvider visible={editDrawerState}>
                    <EditDrawer
                        title={"Настроить группу"}
                        initialValues={editData}
                        onClose={() => setEditDrawerState(false)}
                        onSave={onSaveEdit}
                    />
                </VisibilityProvider>
            )}
        </>
    )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`